import React from 'react';
import styles from './Status.module.scss';
import DotsIcon from '../../assets/icons/16/dots.svg';
import Select from "../Select";
import {StatusPropsInterface} from "./Status.props.interface";

const Status: React.FC<StatusPropsInterface> = (
    {
        children,
        type = 'success',
        size = 'medium',
        data,
        direction,
        onChange,
        ...rest
    }) => {

    return (
        <div className={[
            styles.container,
            styles[type],
            styles[size]
        ].filter(x => x ?? x).join(' ')} {...rest}>
            <p className={styles.status}>
                {children}
            </p>
            {data ? <Select
                data={data}
                direction={direction}
                onChange={onChange}>
                <DotsIcon className={styles.action}/>
            </Select> : null}
        </div>
    );
};

export default Status;
